/* U Brands scroll effects — staggered reveals, soft image unveil, blur-in text,
   word-by-word headlines, hero zoom-out, gentle banner parallax.
   Config from window.UBScrollFX. Respects prefers-reduced-motion. No-JS users see everything. */
(function () {
  var CARD_SELECTORS = [
    '.ub-grid > *',
    '.ub-related__grid > .ub-card',
    '.blog-articles > *',
    '.product-grid > .grid__item',
    '.collection-list > .grid__item',
    '.multicolumn-list > .grid__item',
    '.collection-header__item',
    '.gspf-product-list > *',
    '.globo-filter-products > *'
  ];
  var SOLO_SELECTORS = [
    '.collection-hero__text-wrapper',
    '.ub-featured__inner',
    '.rich-text__wrapper',
    '.image-with-text__grid',
    '.ub-inline-cta',
    '.ub-author',
    '.collection-seo-description details'
  ];
  var HEADLINE_SELECTORS = [
    '.banner__heading',
    '.ub-blog-hero__title',
    '.title-wrapper .title',
    '.title-wrapper-with-link .title',
    '.collection-hero__title',
    '.collection-header-title',
    '.rich-text__heading'
  ];

  /* Conservative motion ranges so banner artwork (often contains text) never crops noticeably. */
  var HERO_ZOOM_START = 1.06;
  var HERO_ZOOM_RANGE = 0.06; /* eases to 1.00 */
  var DRIFT_SCALE = 1.04;
  var DRIFT_MAX = 12; /* px */

  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function init() {
    var cfg = window.UBScrollFX || {};
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var stagger = typeof cfg.stagger === 'number' ? cfg.stagger : 90;
    var counts = new Map();

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ub-fx-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

    function arm(el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.95 && r.bottom > 0) {
        setTimeout(function () { el.classList.add('ub-fx-in'); }, 30);
      } else {
        io.observe(el);
      }
    }

    function tag(el, grouped, isText) {
      if (el.classList.contains('ub-fx')) return;
      var delay = 0;
      if (grouped && el.parentElement) {
        var key = el.parentElement;
        var n = counts.get(key) || 0;
        delay = Math.min(n * stagger, stagger * 6);
        counts.set(key, n + 1);
      }
      el.classList.add('ub-fx');
      if (isText) el.classList.add('ub-fx--text');
      el.style.setProperty('--ub-fx-delay', delay + 'ms');
      if (cfg.zoom !== false) {
        var media = el.querySelector('.card__media, .ub-card__media, .article-card__image-wrapper');
        if (media) media.classList.add('ub-fx-media');
      }
      arm(el);
    }

    /* Split plain-text headlines into words for staggered word reveal. */
    function splitHeadline(el) {
      if (el.dataset.ubSplit || el.classList.contains('ub-fx')) return;
      if (el.children.length > 0) { tag(el, false, true); return; }
      var text = (el.textContent || '').trim();
      if (!text || text.length > 90) { tag(el, false, true); return; }
      var words = text.split(/\s+/);
      el.innerHTML = words.map(function (w, i) {
        return '<span class="ub-word" style="--ub-word-i:' + i + '">' + escapeHtml(w) + '</span>';
      }).join(' ');
      el.dataset.ubSplit = '1';
      el.classList.add('ub-words', 'ub-fx', 'ub-fx--words');
      arm(el);
    }

    function scan(root) {
      var scope = root.querySelectorAll ? root : document;
      scope.querySelectorAll(CARD_SELECTORS.join(',')).forEach(function (el) { tag(el, true, false); });
      scope.querySelectorAll(SOLO_SELECTORS.join(',')).forEach(function (el) { tag(el, false, true); });
      scope.querySelectorAll(HEADLINE_SELECTORS.join(',')).forEach(function (el) { splitHeadline(el); });
    }

    /* Timer (not rAF) so this also runs in background tabs. */
    setTimeout(function () { scan(document); }, 60);

    /* Catch grids injected later (e.g. Smart Product Filter rebuilds collection grids). */
    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; scan(document); }, 250);
    });
    mo.observe(document.body, { childList: true, subtree: true });

    /* Safety net for tabs hidden at load. */
    document.addEventListener('visibilitychange', function onVis() {
      if (document.visibilityState === 'visible') {
        document.removeEventListener('visibilitychange', onVis);
        document.querySelectorAll('.ub-fx:not(.ub-fx-in)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.95 && r.bottom > 0) {
            el.classList.add('ub-fx-in');
            io.unobserve(el);
          }
        });
      }
    });

    /* Banner parallax + hero zoom-out. Skips Dawn's own parallax images. */
    var plx = [];
    document.querySelectorAll('.banner__media img:not(.parallax), .ub-hero__media img').forEach(function (img) {
      img.classList.add('ub-plx');
      plx.push(img);
    });
    /* The first banner image near the top of the page becomes the zoom-out hero. */
    var heroImg = null;
    plx.forEach(function (img) {
      if (heroImg) return;
      var box = img.parentElement.getBoundingClientRect();
      if (box.top + window.scrollY < window.innerHeight * 0.6) heroImg = img;
    });

    if (plx.length) {
      var ticking = false;
      var drift = function () {
        ticking = false;
        var vh = window.innerHeight;
        plx.forEach(function (img) {
          var box = img.parentElement.getBoundingClientRect();
          if (box.bottom < 0 || box.top > vh) return;
          if (img === heroImg) {
            var p = Math.min(1, Math.max(0, window.scrollY / vh));
            var s = HERO_ZOOM_START - HERO_ZOOM_RANGE * p;
            img.style.transform = 'scale(' + s.toFixed(3) + ')';
          } else {
            var center = box.top + box.height / 2 - vh / 2;
            var y = Math.max(-DRIFT_MAX, Math.min(DRIFT_MAX, center * -0.04));
            img.style.transform = 'scale(' + DRIFT_SCALE + ') translateY(' + y.toFixed(1) + 'px)';
          }
        });
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(drift); }
      }, { passive: true });
      drift();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
